<template>
  <div class="wraper">
    <div class="title">
      <img src="@/assets/img/YanShiHuiBao/Title1.png" alt="" />
    </div>
    <div class="list">
      <div
        class="item"
        :class="selectIndex == index ? 'item_ac' : ''"
        @click="chooseIt(index)"
        v-for="(item, index) in list"
        :key="item.name"
      >
        <img src="@/assets/img/YanShiHuiBao/list_icon.png" alt="" />
        <p>{{ item.name }}</p>
        <img
          class="btn"
          @click.stop="moveUp(item, index)"
          src="@/assets/img/YanShiHuiBao/up.png"
          alt=""
        />
        <img
          class="btn"
          @click.stop="moveDown(item, index)"
          src="@/assets/img/YanShiHuiBao/down.png"
          alt=""
        />
        <img
          class="btn"
          @click.stop="editItem(item, index)"
          src="@/assets/img/YanShiHuiBao/edit.png"
          alt=""
        />
        <img
          class="btn"
          @click.stop="deleteItem(item, index)"
          src="@/assets/img/YanShiHuiBao/delete.png"
          alt=""
        />
      </div>
    </div>
    <div class="bottom">
      <div class="bar">
        <div class="progress" ref="progressBar"></div>
      </div>
      <div class="btns">
        <div class="btn" @click="add">
          <img src="@/assets/img/YanShiHuiBao/add.png" />
        </div>
        <div class="btn" @click="playPrev">
          <img src="@/assets/img/YanShiHuiBao/prev.png" />
        </div>
        <div class="btn" @click="changePlay(false)" v-show="isPlay">
          <img src="@/assets/img/YanShiHuiBao/pause.png" />
        </div>
        <div class="btn" @click="changePlay(true)" v-show="!isPlay">
          <img src="@/assets/img/YanShiHuiBao/play.png" />
        </div>
        <div class="btn" @click="playNext">
          <img src="@/assets/img/YanShiHuiBao/next.png" />
        </div>
        <div class="btn" @click="changePlayMode" v-show="playMode">
          <img src="@/assets/img/YanShiHuiBao/loop.png" />
        </div>
        <div class="btn" @click="changePlayMode" v-show="!playMode">
          <img src="@/assets/img/YanShiHuiBao/random.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clearTimeout, setTimeout } from 'timers'
import UEapi from '../../utils/UEapi/UEapi'

export default {
  components: {},
  props: ['list'],
  data() {
    return {
      playMode: true, // loop random // 播放模式
      isPlay: false, // 播放状态
      selectIndex: -1, // 选中索引值
      playIndex: -1,
      playList: [],
      playAllTime: 0,
      progressTimer: null,
      progressIndex: -1,
    }
  },
  methods: {
    add() {
      this.$emit('add')
    },
    moveUp(item, index) {
      this.$emit('moveUp', index)
    },
    moveDown(item, index) {
      this.$emit('moveDown', index)
    },
    editItem(item, index) {
      this.$emit('editItem', index)
    },
    deleteItem(item, index) {
      this.$emit('deleteItem', index)
    },
    // 播放相关
    chooseIt(index) {
      if (index >= 0) {
        this.selectIndex = index
      }
      this.playList = this.list[this.selectIndex]
      this.playIndex = 0
      this.calcLineTime()
    },
    play() {
      this.setProgressBar()
      let cameraInfo = this.getCameraInfo(this.playList.views[this.playIndex])
      let txt = this.playList.views[this.playIndex].explain || ''
      this.$store.commit('setTipTxt', txt)
      this.timeOut && clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        if (!this.isPlay) {
          return
        }
        // UEapi.Camera.setCamera(cameraInfo)
        window.appInstance.uniCall('setCamera', cameraInfo, (res) => {
          // setTimeout(() => {
          // this.playIndex++
          // // 如果播放到最后了
          // if (this.playIndex >= this.playList.views.length) {
          //   // 判断播放模式
          //   if (this.playMode) {
          //     // 循环
          //     this.playNext()
          //   } else {
          //     // 随机
          //     this.selectIndex = parseInt(Math.random() * this.list.length)
          //     this.chooseIt()
          //     this.play()
          //   }
          // } else {
          //   this.play()
          // }
          // }, this.playList.views[this.playIndex].flyTime * 1000)
        })
      }, this.playList.views[this.playIndex].delay * 1000 + 200)
    },
    playPrev() {
      if (this.selectIndex <= 0) {
        return
      }
      this.selectIndex--
      this.chooseIt()
      this.play()
    },
    playNext() {
      this.selectIndex++
      this.selectIndex %= this.list.length
      this.chooseIt()
      this.play()
    },
    changePlay(flag) {
      this.isPlay = flag
      if (flag) {
        this.play()
      } else {
        this.progressTimer && clearInterval(this.progressTimer)
        this.timeOut && clearTimeout(this.timeOut)
      }
    },
    changePlayMode() {
      this.playMode = !this.playMode
    },
    getCameraInfo(info) {
      return {
        ...info.cameraInfo,
        fly: true,
        duration: info.flyTime == 0 ? 0.1 : info.flyTime,
      }
    },
    calcLineTime() {
      this.$refs.progressBar.style.transition = 'none'
      this.$refs.progressBar.style.width = '0px'
      this.progressIndex = 0
      this.playAllTime = this.playList.views.reduce(
        (prev, item, index, arr) => {
          if (!this.playList.views[this.playIndex].isShow) {
            return prev
          }
          prev += item.flyTime
          if (index == arr.length - 1) {
            return prev
          } else {
            return (prev += item.delay)
          }
        },
        0
      )
      console.log(this.playAllTime)
    },
    setProgressBar() {
      let step = 600 / this.playAllTime
      this.progressTimer && clearInterval(this.progressTimer)
      this.progressTimer = setInterval(() => {
        this.progressIndex++
        this.$refs.progressBar.style.transition = 'width 1s linear'
        this.$refs.progressBar.style.width = step * this.progressIndex + 'px'
      }, 1000)
    },
  },

  mounted() {
    window.appInstance.uniCall('addEventListener', {
      eventName: 'onSetCameraEnd',
      callback: (res) => {
        console.log('onSetCameraEnd', res)
        if (this.isPlay) {
          this.playIndex++
          if (!this.playList.views[this.playIndex]?.isShow) {
            this.playIndex++
          }
          // 如果播放到最后了
          if (this.playIndex >= this.playList.views.length) {
            // 判断播放模式
            if (this.playMode) {
              // 循环
              this.playNext()
            } else {
              // 随机
              this.selectIndex = parseInt(Math.random() * this.list.length)
              this.chooseIt()
              this.play()
            }
          } else {
            this.play()
          }
        }
      },
    })
  },
  beforeDestroy() {
    appInstance.uniCall('removeEventListener', {
      eventName: 'onSetCameraEnd',
    })
  },
}
</script>

<style lang="less" scoped>
.wraper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.title {
  background-color: rgba(18, 32, 46, 0.75);
  height: 75px;
  border: 1px #ccc solid;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding-left: 30px;
  flex: 0 0 auto;
}
.list {
  background-color: rgba(18, 32, 46, 0.75);
  height: 100%;
  border: 1px #ccc solid;
  box-sizing: border-box;
  flex: 1 1 auto;
  background: repeating-linear-gradient(
    to bottom,
    rgba(6, 56, 83, 0.65) 0px,
    rgba(6, 56, 83, 0.65) 70px,
    rgba(18, 32, 46, 0.75) 70px,
    rgba(18, 32, 46, 0.75) 140px
  );
  .item_ac {
    background-color: rgba(24, 155, 250, 0.5) !important;
  }
  .item {
    &:hover {
      background-color: rgba(24, 155, 250, 0.5);
      .btn {
        display: block;
      }
    }
    padding-left: 75px;
    height: 70px;
    display: flex;
    align-items: center;
    p {
      width: 360px;
      color: #fff;
      font-size: 28px;
      margin-left: 10px;
    }
    .btn {
      margin-left: 15px;
      display: none;
    }
  }
}
.bottom {
  background-color: #000000;
  height: 95px;
  box-sizing: border-box;
  border: 1px #ccc solid;
  flex: 0 0 auto;
  padding-top: 15px;
  .bar {
    width: 600px;
    border-radius: 6px;
    margin: 0 auto;
    height: 12px;
    background-color: #4d5459;
    .progress {
      width: 0px;
      border-radius: 6px;
      height: 12px;
      background-color: #189bfa;
      position: relative;
      min-width: 12px;
      max-width: 600px;
      &::after {
        content: '';
        position: absolute;
        top: 0px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #fff;
        right: 0;
      }
    }
  }
  .btns {
    display: flex;
    font-size: 40px;
    color: #fff;
    align-items: center;
    height: 70px;
    justify-content: space-around;
    .btn {
      height: 70px;
      display: flex;
      align-items: center;
      text-align: center;
      box-sizing: border-box;
      padding: 10px;
    }
  }
}
</style>
